import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import Button from "core/buttons/button/Button";
import { DELIVERY_NOTE_RECEIVED_TEMPLATE_ACTIONS } from "constants/forms";
import DeliveryNotePreviewModalShell from "./DeliveryNotePreviewModalShell";
import DeliveryNoteTemplatePreview from "./DeliveryNoteTemplatePreview";
import useDeliveryNoteDocumentImages from "./useDeliveryNoteDocumentImages";

const DeliveryNoteTemplatePreviewModal = ({
  template,
  onClose,
  onImport,
  isImporting,
}) => {
  const { snapshot, resolveImage } = useDeliveryNoteDocumentImages(template);

  if (!template) return null;

  return (
    <DeliveryNotePreviewModalShell
      id="delivery-note-template-preview-modal"
      title={template.name}
      onClose={onClose}
      actions={
        <>
          <Button
            type="button"
            className="btn-small btn-outline"
            onClick={onClose}
            id="delivery-note-received-template-close"
          >
            <FormattedMessage
              {...DELIVERY_NOTE_RECEIVED_TEMPLATE_ACTIONS.close}
            />
          </Button>
          {onImport && (
            <Button
              type="button"
              color="btn-small gray-700"
              onClick={() => onImport(template)}
              disabled={isImporting}
              id="delivery-note-received-template-import-from-preview"
            >
              <FormattedMessage
                {...DELIVERY_NOTE_RECEIVED_TEMPLATE_ACTIONS.importFromPreview}
              />
            </Button>
          )}
        </>
      }
    >
      <DeliveryNoteTemplatePreview
        snapshot={snapshot}
        resolveImage={resolveImage}
        showTitle={false}
      />
    </DeliveryNotePreviewModalShell>
  );
};

DeliveryNoteTemplatePreviewModal.propTypes = {
  template: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onImport: PropTypes.func,
  isImporting: PropTypes.bool,
};

export default DeliveryNoteTemplatePreviewModal;
